@if (display) {
  <div class="app-loading">
    <div class="logo">
      <img src="../../../assets-common/{{ oemId }}/logo.svg" alt="" draggable="false" />
    </div>
    <div class="loading-container">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <!--  <div class="loading-circle"></div>-->
  </div>
}
